export default "__VITE_ASSET__hzAWvZ5M__"